<div class="row">
  <rask-button
    aid="buttonHamtaViol3Xml"
    color="primary"
    (click)="hamtaViol3XML()"
    [disabled]="canGetXML()">
    Hämta XML
  </rask-button>
</div>
<rask-toggle-panel label="Förstaledskontrakt" [defaultExpanded]="false">
  <div class="row">
    <rask-textarea class="col-8 viol3xml-textbox-style"
      label="Förstaledskontrakt"
      [(ngModel)]="forstaledskontraktSelectedXmlInfo.xml"
      [rows]="45">
    </rask-textarea>
    <div class="col-4">
      <div class="row-fluid">
        <rask-textarea class="col-6 viol3xml-textbox-style"
          label="Resultat"
          [ngModel]="forstaledskontraktXmlSendResult"
          [rows]="20"
          disabled>
        </rask-textarea><rask-textarea class="col-6 viol3xml-textbox-style"
        label="Ack/Nack Xml"
        [(ngModel)]="forstaledskontraktAckNackXml"
        [rows]="21">
      </rask-textarea>
    </div>
  </div>
</div>
<div class="row">
  <rask-button
    class="col-8"
    aid="buttoSkickaForstaledskontraktViol3Xml"
    (click)="skickaForstaledskontrakXml()"
    color="primary">
    Skicka
  </rask-button>
  <rask-button
    class="col-2 ack-button"
    aid="buttonHamtaAckNackXml"
    (click)="hamtaForstaledskontrakAckNackXml()"
    [disabled]="canGetXML()"
    color="primary">
    Hämta Ack/Nack XML
  </rask-button>
  <rask-button
    class="col-2"
    aid="buttonSkickaAckNackXml"
    (click)="skickaForstaledskontrakAckNackXml()"
    [disabled]="canGetXML()"
    color="primary">
    Skicka Ack/Nack
  </rask-button>
</div>
</rask-toggle-panel>
<rask-toggle-panel label="Avtalsobjekt" [defaultExpanded]="false">
  <div class="row">
    @if (deliverySourceInfoList) {
      <rask-selector
        class="col-6"
        label="Välj"
        [(ngModel)]="deliverySourceSelectedXmlInfo"
        [values]="deliverySourceInfoList"
        [viewFormatter]="formatter">
      </rask-selector>
    }
  </div>
  <div class="row">
    <rask-textarea class="col-8 viol3xml-textbox-style"
      label="Avtalsobjekt"
      [(ngModel)]="deliverySourceSelectedXmlInfo.xml"
      [rows]="45">
    </rask-textarea>
    <div class="col-4">
      <div class="row-fluid">
        <rask-textarea class="col-6 viol3xml-textbox-style"
          label="Resultat"
          [(ngModel)]="deliverySourceXmlSendResult"
          [rows]="20"
          disabled>
        </rask-textarea><rask-textarea class="col-6 viol3xml-textbox-style"
        label="Ack/Nack Xml"
        [(ngModel)]="deliverySourceAckNackXml"
        [rows]="21">
      </rask-textarea>
    </div>
  </div>
</div>
<div class="row">
  <rask-button
    class="col-8"
    aid="buttoSkickaAvtalsobjektViol3Xml"
    (click)="skickaAvtalsobjektXml()"
    color="primary">
    Skicka
  </rask-button>
  <rask-button
    class="col-2 ack-button"
    aid="buttonHamtaAckNackXml"
    (click)="hamtaDeliverySourceAckNackXml()"
    [disabled]="!deliverySourceSelectedXmlInfo.key"
    color="primary">
    Hämta Ack/Nack XML
  </rask-button>
  <rask-button
    class="col-2"
    aid="buttonSkickaDeliverySourceAckNackXml"
    (click)="skickaDeliverySourceAckNackXml()"
    [disabled]="!deliverySourceSelectedXmlInfo.key"
    color="primary">
    Skicka Ack/Nack
  </rask-button>
</div>
</rask-toggle-panel>
<rask-toggle-panel label="Produktionsunderlag" [defaultExpanded]="false">
  <div class="row">
    @if (forestLoggingInformatioList) {
      <rask-selector
        class="col-6"
        label="Välj"
        [(ngModel)]="forestLoggingInformationSelectedXmlInfo"
        [values]="forestLoggingInformatioList"
        [viewFormatter]="formatter">
      </rask-selector>
    }
  </div>
  <div class="row">
    <rask-textarea class="col-8 viol3xml-textbox-style"
      label="Produktionsunderlag"
      [(ngModel)]="forestLoggingInformationSelectedXmlInfo.xml"
      [rows]="45">
    </rask-textarea>
    <div class="col-4">
      <div class="row-fluid">
        <rask-textarea class="col-4 viol3xml-textbox-style"
          label="Resultat"
          [ngModel]="forestloggingXmlSendResult"
          [rows]="20"
          disabled>
        </rask-textarea>
        <rask-textarea class="col-4 viol3xml-textbox-style"
          label="Ack/Nack Xml"
          [(ngModel)]="forestLoggingInformationAckNackXml"
          [rows]="21">
        </rask-textarea>
      </div>
    </div>
  </div>
  <div class="row">
    <rask-button
      class="col-8"
      aid="buttoSkickaProduktionsunderlagViol3Xml"
      (click)="skickaProduktionsunderlagXml()"
      color="primary">
      Skicka
    </rask-button>
    <rask-button
      class="col-2 ack-button"
      aid="buttonHamtaForestLoggingAckNackXml"
      (click)="hamtaForestloggingAckNackXml()"
      [disabled]="!forestLoggingInformationSelectedXmlInfo.key"
      color="primary">
      Hämta Ack/Nack XML
    </rask-button>
    <rask-button
      class="col-2"
      aid="buttonSkickaForestloggingAckNackXml"
      (click)="skickaForestLoggingInstructionAckNackXml()"
      [disabled]="!forestLoggingInformationSelectedXmlInfo.key"
      color="primary">
      Skicka Ack/Nack
    </rask-button>
  </div>
</rask-toggle-panel>
<rask-toggle-panel label="Destinering" [defaultExpanded]="false">
  <div class="row">
    @if (orderConfirmationXmlInfoList) {
      <rask-selector
        class="col-6"
        label="Välj"
        [(ngModel)]="orderConfirmationSelectedXmlInfo"
        [values]="orderConfirmationXmlInfoList"
        [viewFormatter]="formatter">
      </rask-selector>
    }
  </div>
  <div class="row">
    <rask-textarea class="col-8 viol3xml-textbox-style"
      label="Destinering"
      [(ngModel)]="orderConfirmationSelectedXmlInfo.xml"
      [rows]="45">
    </rask-textarea>
    <div class="col-4">
      <div class="row-fluid">
        <rask-textarea class="col-4 viol3xml-textbox-style"
          label="Resultat"
          [ngModel]="orderConfirmationXmlSendResult"
          [rows]="20"
          disabled>
        </rask-textarea>
        <rask-textarea class="col-4 viol3xml-textbox-style"
          label="Ack/Nack Xml"
          [(ngModel)]="orderConfirmationAckNackXml"
          [rows]="21">
        </rask-textarea>
      </div>
    </div>
  </div>
  <div class="row">
    <rask-button
      class="col-8"
      aid="buttoSkickaDestineringViol3Xml"
      (click)="skickaDestinerasortimentXml()"
      color="primary">
      Skicka
    </rask-button>
    <rask-button
      class="col-2 ack-button"
      aid="buttonHamtaForestLoggingAckNackXml"
      (click)="hamtaOrderConfirmationAckNackXml()"
      [disabled]="!orderConfirmationSelectedXmlInfo.key"
      color="primary">
      Hämta Ack/Nack XML
    </rask-button>
    <rask-button
      class="col-2"
      aid="buttonSkickaForestloggingAckNackXml"
      (click)="skickaOrderConfirmationAckNackXml()"
      [disabled]="!orderConfirmationSelectedXmlInfo.key"
      color="primary">
      Skicka Ack/Nack
    </rask-button>
  </div>
</rask-toggle-panel>
<rask-toggle-panel label="Transportunderlag" [defaultExpanded]="false">
  <div class="row">
    @if (loadTenderInfoList) {
      <rask-selector
        class="col-6"
        label="Välj"
        [(ngModel)]="loadTenderSelectedXmlInfo"
        [values]="loadTenderInfoList"
        [viewFormatter]="formatter">
      </rask-selector>
    }
  </div>
  <div class="row">
    <rask-textarea class="col-8 viol3xml-textbox-style"
      label="Transportunderlag"
      [(ngModel)]="loadTenderSelectedXmlInfo.xml"
      [rows]="45">
    </rask-textarea>
    <div class="col-4">
      <div class="row-fluid">
        <rask-textarea class="col-4 viol3xml-textbox-style"
          label="Resultat"
          [ngModel]="loadTenderInfoXmlSendResult"
          [rows]="20"
          disabled>
        </rask-textarea>
        <rask-textarea class="col-4 viol3xml-textbox-style"
          label="Ack/Nack Xml"
          [(ngModel)]="loadTenderAckNackXml"
          [rows]="21">
        </rask-textarea>
      </div>
    </div>
  </div>
  <div class="row">
    <rask-button
      class="col-8"
      aid="buttoSkickaTransportunderlagViol3Xml"
      (click)="skickaTransportunderlagXml()"
      color="primary">
      Skicka
    </rask-button>
    <rask-button
      class="col-2 ack-button"
      aid="buttonHamtaForestLoggingAckNackXml"
      (click)="hamtaLoadTenderAckNackXml()"
      [disabled]="!loadTenderSelectedXmlInfo.key"
      color="primary">
      Hämta Ack/Nack XML
    </rask-button>
    <rask-button
      class="col-2"
      aid="buttonSkickaForestloggingAckNackXml"
      (click)="skickaLoadTenderAckNackXml()"
      [disabled]="!loadTenderSelectedXmlInfo.key"
      color="primary">
      Skicka Ack/Nack
    </rask-button>
  </div>
</rask-toggle-panel>
